module.exports = __webpack_public_path__ + "static/2005-greetings-f7d22bb1a694c506c64daebc0a36a3de.jpg";